import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { genericColor } from "~/lib/resolvers";
import { Grid } from "~/components-shared";
const Wrapper = styled(Grid)`
  opacity: ${_ref => {
  let {
    $opacity
  } = _ref;
  return $opacity;
}};
  position: relative;
  gap: 4px;
  border-radius: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.shape.borderRadius.primary;
}};
  background-color: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return genericColor(theme, "translucentPrimary");
}};
  height: ${_ref4 => {
  let {
    $height,
    theme
  } = _ref4;
  return `${$height * theme.spacing.step}px`;
}};
  ${_ref5 => {
  let {
    $maxWidth
  } = _ref5;
  return $maxWidth && `max-width: ${$maxWidth}`;
}};
  ${_ref6 => {
  let {
    $s,
    theme
  } = _ref6;
  return theme.spacing.resolve(theme, $s);
}};
  transition: grid-template 1000ms cubic-bezier(0.53, -0.19, 0.4, 1.08);
`;
const Bar = styled.div`
  top: 0;
  ${_ref7 => {
  let {
    $hasLabel
  } = _ref7;
  return $hasLabel && `cursor: pointer`;
}};
  height: 100%;
  position: relative;
  background-color: ${_ref8 => {
  let {
    theme,
    $color
  } = _ref8;
  return genericColor(theme, $color);
}};
  transition: all 1000ms cubic-bezier(0.53, -0.19, 0.4, 1.08),
    background-color 1000ms cubic-bezier(0.53, -0.19, 0.4, 1.08), box-shadow 300ms cubic-bezier(0.53, -0.19, 0.4, 1.08);
  border-radius: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.shape.borderRadius.primary;
}};
  box-shadow: 0 0 0 0 ${_ref10 => {
  let {
    theme,
    $color
  } = _ref10;
  return genericColor(theme, $color);
}};

  &:hover {
    box-shadow: 0 0 0 2px ${_ref11 => {
  let {
    theme,
    $color
  } = _ref11;
  return genericColor(theme, $color);
}};
    z-index: 2;
  }
`;
const Progress = _ref12 => {
  let {
    values = [],
    colors = [],
    labels = [],
    opacity = 1,
    maxWidth,
    height = 7,
    s,
    children,
    ...rest
  } = _ref12;
  const [animatedWidth, setAnimatedWidth] = useState(0);
  let totalValue = 0;
  const filteredData = values.map((value, index) => ({
    value,
    color: colors[index],
    label: labels[index]
  })).filter(_ref13 => {
    let {
      value
    } = _ref13;
    return value;
  });
  useEffect(() => {
    setTimeout(() => setAnimatedWidth(100), 1000);
  }, [JSON.stringify(filteredData)]);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    cols: filteredData.length,
    template: filteredData.map(_ref14 => {
      let {
        value
      } = _ref14;
      return `calc(${value}% - ${filteredData.length > 1 ? "2px" : "0px"})`;
    }).join(" "),
    $opacity: opacity,
    $maxWidth: maxWidth,
    $height: height,
    align: "start",
    $s: s
  }, rest), filteredData.map((_ref15, index) => {
    let {
      value,
      label,
      color
    } = _ref15;
    const left = totalValue;
    totalValue += value;
    return /*#__PURE__*/React.createElement(Bar, {
      key: index,
      "data-tooltip-id": label ? "general-tooltip" : undefined,
      "data-tooltip-content": label,
      "data-tooltip-float": true,
      $left: left,
      $color: color || "primary",
      $hasLabel: !!label,
      style: {
        width: `${animatedWidth}%`
      }
    });
  }), children);
};
export default Progress;